import React from 'react'
import { extractTextFromChildren } from '../../utils/DomUtils'
import { NOTIFICATION_DURATION } from './const'
import './notification.css'

/**
 * Calculate notification duration based on reading time
 * Rule: BASE_SECONDS + 1 extra second for every WORDS_PER_EXTRA_SECOND words, minimum MINIMUM_SECONDS
 * @param {string|React.ReactNode} message - The notification message (can be string or React component)
 * @param {string|React.ReactNode} description - The notification description (can be string or React component)
 * @returns {number} Duration in seconds
 */
export const calculateNotificationDuration = (message, description) => {
  // Extract text content
  const messageText =
    typeof message === 'string' ? message : extractTextFromChildren(message)
  const descriptionText =
    typeof description === 'string'
      ? description
      : extractTextFromChildren(description)

  const combinedText = `${messageText} ${descriptionText}`.trim()

  // More efficient word counting - avoid creating intermediate arrays
  const wordCount = combinedText ? combinedText.split(/\s+/).length : 0

  // Base duration + 1 second per WORDS_PER_EXTRA_SECOND words (rounded up)
  const extraSeconds = Math.ceil(
    wordCount / NOTIFICATION_DURATION.WORDS_PER_EXTRA_SECOND
  )
  const calculatedDuration = Math.max(
    NOTIFICATION_DURATION.BASE_SECONDS + extraSeconds,
    NOTIFICATION_DURATION.MINIMUM_SECONDS
  )

  return calculatedDuration
}
